"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrl = void 0;
const getUrl = ({ set, icon, version = '2' }) => {
    // return `https://unpkg.com/iconista@${version}/sets/${set}/${icon}.svg`;
    return `https://cdn.jsdelivr.net/npm/iconista@${version}/sets/${set}/${icon}.svg`;
};
exports.getUrl = getUrl;
